var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isMobile())?_c('div',[_c('NavbarDesktop')],1):_c('div',[_c('NavbarMobile')],1)}
var staticRenderFns = []

export { render, staticRenderFns }